import { useEffect, useState } from 'react';
import { Drawer, Empty } from 'antd';
import { observer } from 'mobx-react';
import moment from 'moment';
import { DayOfWeek, TimeSlotsConfigurationForm, TimeSlotsConfigurationProps } from '@modules/timetable';
import { weekDays } from '@data/weekDays';
import { useMst } from '@models/Root';

export const TimeSlotsConfiguration = observer(
  ({ timeSlotsConfigurationVisible, setTimeSlotsConfigurationVisible }: TimeSlotsConfigurationProps) => {
    const { week, batch } = useMst().timetable;
    const [daysOfWeek, setDaysOfWeek] = useState<DayOfWeek[]>([]);

    useEffect(() => {
      if (week) {
        const startTime = moment().year(week.year()).week(week.week()).startOf('isoWeek');

        const newDaysOfWeek: DayOfWeek[] = weekDays.map((weekDay, index) => ({
          name: weekDay,
          date: startTime.clone().add(index, 'days').format('MMM Do YYYY'),
        }));

        setDaysOfWeek(newDaysOfWeek);
      }
    }, [week]);

    return (
      <Drawer
        width={600}
        title="Configure Timetable"
        placement="right"
        visible={timeSlotsConfigurationVisible}
        onClose={() => {
          setTimeSlotsConfigurationVisible(false);
        }}
      >
        {!timeSlotsConfigurationVisible || daysOfWeek.length === 0 || !batch ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Select a week and a batch first." />
        ) : (
          <TimeSlotsConfigurationForm
            daysOfWeek={daysOfWeek}
            setTimeSlotsConfigurationVisible={setTimeSlotsConfigurationVisible}
          />
        )}
      </Drawer>
    );
  },
);
